<template>
  <div
    class="cs-app"
    @touchstart="onGaryTouchStart"
    @touchend="onGrayTouchEnd"
    @mousedown="onGaryMousedown"
    @mouseup="onGrayMouseup"
  >
    <router-view />
  </div>
</template>

<script lang="ts">
import { grayService } from "./service/gray";

export default {
  setup() {
    let timeoutId = -1;

    const onGaryTouchStart = (event: TouchEvent) => {
      const { clientX, clientY } = event.changedTouches[0];
      if (window.innerWidth - clientX > 40 || clientY > 40) return;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        grayService.debug = !grayService.debug;
      }, 5000);
    };

    const onGrayTouchEnd = () => {
      window.clearTimeout(timeoutId);
    };

    const onGaryMousedown = (event: MouseEvent) => {
      const { clientX, clientY } = event;
      if (window.innerWidth - clientX > 40 || clientY > 40) return;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        grayService.debug = !grayService.debug;
      }, 5000);
    };

    const onGrayMouseup = () => {
      window.clearTimeout(timeoutId);
    };

    return { onGaryTouchStart, onGrayTouchEnd, onGaryMousedown, onGrayMouseup };
  },
};
</script>

<style lang="scss" scoped>
.cs-app {
  height: 100%;
  width: 100%;
}
</style>
